import { BaseControl } from '.';
import TinyMCE from '../../../common/TinyMCE';

/**
 * @typedef {object} TextAreaControlOptions
 * @property {number} [rows] - Number of rows
 * @property {number} [cols] - Number of columns
 */

/**
 * @extends {BaseControl<string, TextAreaControlOptions>}
 */
export class TextAreaControl extends BaseControl {

    /** @type {BaseControl<string>['render']} */
    render(value, onChange) {
        return (
            <label className="text-area-control">
                {this.label}
                <br />
                {/* <textarea 
                    value={value} 
                    name={this.label}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={this.description}
                    rows={this.options?.rows}
                    cols={this.options?.cols}
                /> */}
                <TinyMCE body={value} setBody={onChange} />
            </label>
        );
    }
}
